import getApplicationVariant, {
  APPLICATION_VARIANTS
} from 'bento-ordering/utils/getApplicationVariant';

let _isDineInVariant = null;
export default (useCache = true) => {
  if (useCache && _isDineInVariant !== null) {
    return _isDineInVariant;
  }

  _isDineInVariant = getApplicationVariant() === APPLICATION_VARIANTS.DINE_IN;
  return _isDineInVariant;
};
